import Vue from "vue";
import { MLInstaller, MLCreate, MLanguage } from "vue-multilanguage";
// IT
import contentIT from "./assets/content/it/content_IT.json";
import section0IT from "./assets/content/it/intro_IT.json";
import section1IT from "./assets/content/it/section_1_IT.json";
import section2IT from "./assets/content/it/section_2_IT.json";
import section3IT from "./assets/content/it/section_3_IT.json";
import section4IT from "./assets/content/it/section_4_IT.json";
import section5IT from "./assets/content/it/section_5_IT.json";
import section6IT from "./assets/content/it/section_6_IT.json";
import focusIT from "./assets/content/it/focus_IT.json";
import mobileGalleryIT from "./assets/content/it/mobile-gallery_IT.json";

// EN
import contentEN from "./assets/content/en/content_EN.json";
import section0EN from "./assets/content/en/intro_EN.json";
import section1EN from "./assets/content/en/section_1_EN.json";
import section2EN from "./assets/content/en/section_2_EN.json";
import section3EN from "./assets/content/en/section_3_EN.json";
import section4EN from "./assets/content/en/section_4_EN.json";
import section5EN from "./assets/content/en/section_5_EN.json";
import section6EN from "./assets/content/en/section_6_EN.json";
import focusEN from "./assets/content/en/focus_EN.json";
import mobileGalleryEN from "./assets/content/en/mobile-gallery_EN.json";

contentIT.sections.push(section0IT, section1IT, section2IT, section3IT, section4IT, section5IT, section6IT);
contentEN.sections.push(section0EN, section1EN, section2EN, section3EN, section4EN, section5EN, section6EN);

// Mobile gallery
contentIT.mobileGallery = mobileGalleryIT;
contentEN.mobileGallery = mobileGalleryEN;

Vue.use(MLInstaller);

export default new MLCreate({
  initial: "IT",
  save: process.env.NODE_ENV === "production",
  languages: [
    new MLanguage("IT").create({
      content: contentIT,
      focus: focusIT
    }),
    new MLanguage("EN").create({
      content: contentEN,
      focus: focusEN
    })
  ]
});
